import type { Moment } from 'moment';
import moment from 'moment-timezone';
import { checkDateString } from '../utils/formatQuery/utils';

/**
 * Convert a date string to a date string with timezone
 * UTC + 1 hour = 2023-02-09T18:58:51.754+0100
 */
export function getDateTimezoneFormat(value: string | Date, timezoneParam?: string) {
  const timezone = timezoneParam ?? moment.tz.guess();
  const dateInstance: Moment = checkDateString(value)
    ? moment(value).tz(timezone)
    : moment().tz(timezone);
  const offsetInMinutes = dateInstance.utcOffset();
  const offset = (Math.abs(offsetInMinutes) * 6000) / 3600;
  const sign = offsetInMinutes >= 0 ? '+' : '-';
  const offSetString = sign + pad(offset, 4);
  // output
  return moment(dateInstance).format('YYYY-MM-DDTHH:mm:ss.SSS' + offSetString);
}

// convert number to string with leading zeros
export function pad(num: number, size: number) {
  let s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
}
